import React, { Fragment } from 'react';
import { scaleLinear } from 'd3';

import Plot from '../../components/Plot';


function SolarRadiation({ size, sensors }) {
  const radiationScale = scaleLinear().domain([0, Math.max(...sensors.map(sensor => sensor.value))]).range([0, 40]);
        
  return (
    <Plot size={size}>
      {({ xScale, yScale }) => (
        <Fragment>
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgb(255,255,0)', stopOpacity:1 }} />
              <stop offset="100%" style={{ stopColor: 'rgba(255, 255, 255)', stopOpacity: 0}} />
            </linearGradient>
          </defs>
          {sensors.map(sensor => (
            <circle
              cx={xScale(sensor.x)}
              cy={yScale(sensor.y)}
              r={radiationScale(sensor.value)}
              fill="url(#grad1)"
            />
          ))}
        </Fragment>
      )}
    </Plot>
  )
}

SolarRadiation.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
}

export default SolarRadiation;



// WEBPACK FOOTER //
// ./src/plots/SolarRadiation/SolarRadiation.component.js